<template>
  <div class="section">
    <div class="columns is-mobile">
      <div class="column is-three-fifths is-offset-one-fifth">
        <p class="title is-2">Skills</p>
        <p class="subtitle is-4">My engineering is all about mechanical, electronics and software stuff but most of my background comes from software development and as an tech enthusiast.</p>
        <p class="subtitle is-4">I've worked on the industrie, as a teacher, as freelancer and small with companies.</p>
      </div>
    </div>
    <br>
    <div class="container">
      <div class="tile is-ancestor">
        <div class="tile is-vertical is-9">
          <div class="tile">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <p class="title">Mechanical</p>
                <p class="subtitle">Design and 3D printing</p>
                <div class="content">
                  <p>Taking role on the mechanical part of machines, enclosures and the fabrication of final products.</p>
                </div>
              </article>
            </div>
            <div class="tile is-8 is-parent is-vertical">
              <div class="tile is-child box">
                <p class="title is-3">Software</p>
                <div class="content">
                  <p>5+ years of experience in languajes like C#, Python, JS and recently Rust. Applications for mobile, web and even desktop applications that are still in use.</p>
                  <p>Server side maintenance, implementation with Linux servers.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="tile">
            <div class="tile is-8 is-parent">
              <article class="tile is-child box">
                <p class="title">Project development</p>
                <div class="content">
                  <p>Tackling projects from the beggining or already started, taking care of the client requeriments, development process and the correct implementation following methodologies like scrum and agile.</p>
                </div>
              </article>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child box">
                <p class="title">Data science</p>
                <p class="subtitle">certification</p>
                <div class="content">
                  <p>Applying data science from BI for a bussines worlflow to AI and data analysis on robotics projects.</p>
                </div>
              </article>
            </div>
          </div>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <div class="content">
              <p class="title">Electronics</p>
              <p class="subtitle">Embebded systems</p>
              <div class="content">
                <p>For hobby or for job I've been using platforms like the raspberry pi and other development platforms constaly looking on new things to build and try.</p>
                <p>Knowledge of PCB designing and manugacturing from the insdustrie and in-house.</p>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Skills'
  }
</script>
